export default __webpack_public_path__ + "static/media/coconut.1bf2dd7c.png";